import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

import {ContextIdDto, LinkId, Notification} from '@savvy/notification';
import {FloSnackbarComponent} from "../../snackbar/floSnackbar.component";
import {MatDialog} from "@angular/material/dialog";
import {UrlLookupService} from "../../shared/services/urlLookup.service";
import {Customer} from "@savvy/customer";
import {ViewCustomerV2Component} from "../../customer/view-customer-v2/view-customer-v2.component";

@Component({
  selector: 'app-contract-signed-notification',
  templateUrl: './contractSignedNotification.component.html'
})
export class ContractSignedNotificationComponent implements OnInit {

  @Input() notification: Notification;
  @Input() contextIdDto: ContextIdDto;

  @Output() notificationProcessed: EventEmitter<any> = new EventEmitter();

  customer: Customer;

  constructor(private notify: FloSnackbarComponent,
              private urlLookupService: UrlLookupService,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {

  }

  gotoContract() {
    const contractId = this.getLinkId('CONTRACT_ID', this.notification.linkIds);

    const url = this.urlLookupService.portalUrl() + '/contract.html?id=' + this.contextIdDto.contextId +
      '&contractId=' + contractId + this.urlLookupService.getEnv();
    this.urlLookupService.openNewTab(url);
  }



  getLinkId(type: string, linkIds: Array<LinkId>): string {
    let linkIdToRet;

    linkIds.forEach(linkId => {
      if (linkId.linkedIdType === type) {
        linkIdToRet = linkId.linkedId;
      }
    });
    return linkIdToRet;
  }

  viewCustomer(customerId: string) {
    const contextIdDto = this.contextIdDto;
    const viewCustomerModal = this.dialog.open(ViewCustomerV2Component, {
      data: {
        contextIdDto,
        customerId
      },
      maxWidth: '1024px',
      panelClass: [
        'modal-100',
        'helpwindow',
        'petProfileModal'
      ],
      autoFocus: false
    });

    viewCustomerModal.afterClosed()
      .subscribe(
        () => {
        });
  }
}
